export class RequestNotification {
	name: string;
	priorityId: number;
	isRead: boolean;
	color: string;
}
